/* eslint-disable default-param-last */
import { SET_BEARER, SET_CLIENTS, SET_USER_INFO } from '../types'

export function bearer(state = '', action) {
  switch (action.type) {
    case SET_BEARER:
      return action.bearer
    default:
      return state
  }
}

export function userinfo(state = {}, action) {
  switch (action.type) {
    case SET_USER_INFO:
      return action.data
    default:
      return state
  }
}

export function clients(state = {}, action) {
  switch (action.type) {
    case SET_CLIENTS:
      // eslint-disable-next-line no-case-declarations
      const userType = action?.response?.userType
      if (action?.response?.clients && action?.response?.clients.length > 0) {
        return action.response.clients.map((client) => ({
          ...client,
          role: userType === 1 ? 0 : client.role,
          convertUrl: `${process.env.REACT_APP_URL_REDIRECT_GET_DOMAIN}/convert?apiKey=${client.hashId}&`,
        }))
      } return state

    default:
      return state
  }
}
